// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__lEZqY","title":"BackImages_title__oyzNM","images":"BackImages_images__59nGM"};